import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Logistic } from '../Logistic'

@InputType()
export class VoidLogisticShippingLabelArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string
}

export interface IVoidLogisticShippingLabel extends IAction<Logistic, VoidLogisticShippingLabelArgs> {}
